/// <amd-module name="Tfs/Header/Components/LegacyProfileDialogService" />
import * as React from "react";

import { Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";

class LegacyProfileDialogService extends VssService {
    public show(): void {
        const layoutService = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutService.renderCallout((onDismiss: () => void) => {
            return React.createElement(
                WrappedComponent,
                {
                    wrappedType: "legacy",
                    dependencies: ["ms.vss-web.legacy-content"],
                    wrappedProps: {
                        componentType: "legacyProfileDialog",
                        modules: ["Admin/Scripts/LegacyProfileDialogComponent"]
                    }
                },
                null
            );
        });
    }
}

Services.add("LegacyProfileDialogService", { serviceFactory: LegacyProfileDialogService });
